//bid.modules.states
"use scrict";
import {
  bidIdResolver,
  bidResolver,
  selectedServicesResolver,
  typeResolver,
  categoryResolver
} from "./../../../core/resolvers"


const bidEditIndex = {
    name: 'bidedit',
    url: "/application/{bidId}/edit/",
    text: 'Редактировать заявку',
    component: "bidedit",
    lazyLoad: ($transition$) => {
      const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
  
      return import(/* webpackChunkName: "desktop.module" */ "./bid.module")
        .then(mod => $ocLazyLoad.load(mod.BID_MODULE))
        .catch(err => {
          throw new Error("Ooops, something went wrong, " + err);
        });
    },
    params: {
        bidId: null,
        bid: null,
        type: null,
        services: null,
        category: null,
    },
    resolve: {
        bidId:bidIdResolver,
        bid: bidResolver,
        selectedServices: selectedServicesResolver,
        type: typeResolver,
        category:categoryResolver,
      },

  };
const bidStep1Index = {
    name: 'bidedit.step1',
    url: '1/',
    component: 'bideditstep1',
    text: 'Редактировать заявку',
    lazyLoad: ($transition$) => {
      const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
  
      return import(/* webpackChunkName: "desktop.module" */ "./bid.module")
        .then(mod => $ocLazyLoad.load(mod.BID_MODULE))
        .catch(err => {
          throw new Error("Ooops, something went wrong, " + err);
        });
    },

  };

const bidStep2Index = {
    name: 'bidedit.step2',
    url: '2/',
    component: 'bideditstep2',
    text: 'Редактировать заявку',
    lazyLoad: ($transition$) => {
      const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
  
      return import(/* webpackChunkName: "desktop.module" */ "./bid.module")
        .then(mod => $ocLazyLoad.load(mod.BID_MODULE))
        .catch(err => {
          throw new Error("Ooops, something went wrong, " + err);
        });
    },

  };
  
const bidStep3Index = {
    name: 'bidedit.step3',
    url: '3/',
    component: 'bideditstep3',
    text: 'Редактировать заявку',
    lazyLoad: ($transition$) => {
      const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
  
      return import(/* webpackChunkName: "desktop.module" */ "./bid.module")
        .then(mod => $ocLazyLoad.load(mod.BID_MODULE))
        .catch(err => {
          throw new Error("Ooops, something went wrong, " + err);
        });
    },

};

export {
    bidEditIndex,
    bidStep1Index,
    bidStep2Index,
    bidStep3Index
};






// WEBPACK FOOTER //
// ./src/components/desktop/bid/bid.module.states.js